import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

// Shared markdown renderer for AI output.
//
// The default `prose` table styling collapses to ~1 character per column when a
// table is rendered inside a narrow / flex container (no min-width, so the
// browser shrinks every cell and wraps each letter vertically). These component
// overrides force tables to keep their natural width, wrap the table in a
// horizontal-scroll container, and give cells real padding/borders — so tables
// render readably regardless of the surrounding layout.
export const MD_TABLE_COMPONENTS: React.ComponentProps<typeof ReactMarkdown>['components'] = {
  table: ({ node, ...props }) => (
    <div className="my-3 w-full overflow-x-auto rounded-lg border border-gray-200">
      <table className="w-full border-collapse text-sm" style={{ minWidth: 'max-content' }} {...props} />
    </div>
  ),
  thead: ({ node, ...props }) => <thead className="bg-gray-50" {...props} />,
  th: ({ node, ...props }) => (
    <th
      className="border-b border-gray-200 px-3 py-2 text-left font-semibold text-gray-800 align-top whitespace-normal"
      style={{ minWidth: '8rem' }}
      {...props}
    />
  ),
  td: ({ node, ...props }) => (
    <td
      className="border-b border-gray-100 px-3 py-2 text-gray-700 align-top whitespace-normal"
      style={{ minWidth: '8rem' }}
      {...props}
    />
  ),
};

interface Props {
  children: string;
  className?: string;
}

export default function MarkdownContent({ children, className }: Props) {
  return (
    <div className={className ?? 'prose prose-sm max-w-none text-gray-700'}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={MD_TABLE_COMPONENTS}>
        {children || ''}
      </ReactMarkdown>
    </div>
  );
}
